import useSWR from 'swr';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearchV2 = (discoveryService, params, configs, searchAlgoHeaderValue) => {
  const _a = configs || {}, { transform = (data2) => data2 } = _a, swrConfigs = __objRest(_a, ["transform"]);
  const { data, error } = useSWR(params && Object.keys(params).length ? [params, "discovery-search-v2"] : null, async (params2) => {
    const response = await discoveryService.search(params2, searchAlgoHeaderValue);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  return {
    result: data,
    error,
    loading: params && Object.keys(params).length ? !error && !data : false
  };
};

export { useDiscoverySearchV2 };
